<div class="form-group ch-header-item date-picker-cont">
  <div
    class="input-group"
    #inp
    (selected)="selectedDate($event, mainInput)"
    (cancelDaterangepicker)="calendarEventsHandler($event)"
    (applyDaterangepicker)="applyDate($event)"
    (hideDaterangepicker)="calendarEventsHandler($event)"
    (showDaterangepicker)="calendarEventsHandler($event)"
  >
    <span *ngIf="!label || 'Custom Range' === label" class="form-control uneditable-input" name="daterange">
      <span *ngIf="mainInput.start && mainInput.end"> {{ mainInput.start | dateFormat }} - {{ mainInput.end | dateFormat }} </span>
      <span class="default-value" *ngIf="!mainInput.start || !mainInput.end"> Nothing selected </span>
    </span>
    <span *ngIf="label && 'Custom Range' !== label" class="form-control uneditable-input" name="daterange"> {{ label }} </span>
    <span class="input-group-btn">
      <a type="button" class="btn btn-default"> <i class="glyphicon glyphicon-calendar"></i> </a>
    </span>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/daterangepicker/daterangepicker.component.html